import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Autocomplete, TextField } from '@mui/material';

import '../../../scss/Components/_modal.scss';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';

const HEADERS = {
  headers: { Authorization: 'bearer ' + localStorage.getItem('token') },
};

function ModalEUpdate(props) {
  const { notesString } = useTranslationHook();
  const { getEquips, ...modalProps } = props;

  var equipNameDefaultU = localStorage.getItem('equipNameForUPlaceholder');
  var equipDescDefaultU = localStorage.getItem(
    'equipDescriptionForUPlaceholder',
  );
  var equipNotesDefaultU = localStorage.getItem('equipNotesForU');

  const [name, setName] = useState(equipNameDefaultU);
  const [description, setDescription] = useState(equipDescDefaultU);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [notes, setNotes] = useState(equipNotesDefaultU);

  useEffect(() => {
    if (!props.show) return;
    customAxios
      .get(`${GlobalVariables.getURL()}locations-assets/`, HEADERS)
      .then((response) => {
        setLocations(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => console.log(error));
  }, [props.show]);

  const resetFormFields = () => {
    setName(localStorage.getItem('equipNameForUPlaceholder'));
    setDescription(localStorage.getItem('equipDescriptionForUPlaceholder'));
    setSelectedLocations(
      JSON.parse(localStorage.getItem('equipLocationsForU') || '[]'),
    );
    setNotes(localStorage.getItem('equipNotesForU'));
  };

  function updateEquip(event) {
    event.preventDefault();
    if (selectedLocations.length === 0) {
      getToast({
        status: 'error',
        title: 'Selecciona al menos una ubicación.',
      });
      return;
    }
    var updateEquipId = localStorage.getItem('equipIdForUpdate');
    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateEquip/${updateEquipId}`,
        {
          equip_name: name,
          description: description,
          locations: selectedLocations.map((location) => location.id),
          notes,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      )
      .then(
        (response) => {
          console.log(response);
          hide();
        },
        (error) => {
          getToast({
            status: 'error',
            title: 'Error al actualizar tipo de equipo. Vuelve a intentarlo.',
          });
          console.log(error);
        },
      );
  }

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Tipo de equipo actualizado exitosamente en la base de datos.',
    });
    getEquips();
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...modalProps}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar tipo de equipo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="update-equip-form" onSubmit={updateEquip}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Nombre del tipo de equipo"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <Autocomplete
                multiple
                sx={{ width: '100%' }}
                options={locations}
                value={selectedLocations}
                filterSelectedOptions
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name || ''}
                onChange={(event, newValue) => setSelectedLocations(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ubicaciones"
                    required={selectedLocations.length === 0}
                  />
                )}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                multiline
                rows={4}
                sx={{ width: '100%' }}
                label="Características"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type={'text'}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="update-equip-form"
          className="update-modal-button"
          disabled={selectedLocations.length === 0}
        >
          Guardar cambios
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEUpdate;
